module.exports = __webpack_public_path__ + "static/laura_07-6b673f429774a4b70d7e284b7c391cb9.jpg";